import { useEffect, useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { SESSION_STORAGE_KEYS } from '../constants/sessionStorageKeys';
import { glacierPolicyApiGetPolicyPermissionsOptions } from '../heyapi/@tanstack/react-query.gen';

// Custom hook to handle editMode
export const useEditMode = (policyId: string | undefined) => {
  const [editMode, setEditMode] = useState<boolean>(true);

  const { data: permissionsData } = useQuery({
    enabled: policyId !== undefined,
    ...glacierPolicyApiGetPolicyPermissionsOptions({
      path: {
        account_id: policyId!,
      },
    }),
  });

  useEffect(() => {
    // Time travel is a read-only view of a past sequence — short-circuit
    // before applying permission-based editMode so the AgentAuthorityContext
    // stays read-only for every consumer without each form having to remember
    // to also check `isTimeTraveling`.
    if (sessionStorage.getItem(SESSION_STORAGE_KEYS.SEQUENCE_ID)) {
      setEditMode(false);
      return;
    }

    if (
      permissionsData &&
      (permissionsData === 'READ' || permissionsData === 'UNAUTHORIZED')
    ) {
      setEditMode(false);
    }
    if (permissionsData && permissionsData === 'WRITE') {
      setEditMode(true);
    }

    // TODO: Add block if unauthorized & reroute to main screen
  }, [permissionsData]);

  return {
    editMode,
    setEditMode,
  };
};
